// removed by extract-text-webpack-plugin
module.exports = {"ContentLayout":"bJPsqG5-"};


//////////////////
// WEBPACK FOOTER
// ./src/layouts/content/content-layout.styles.scss
// module id = 537
// module chunks = 0